import { render } from "./AjustesOrden.vue?vue&type=template&id=4698fc73"
import script from "./AjustesOrden.vue?vue&type=script&lang=js"
export * from "./AjustesOrden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__